import { Card, Skeleton } from 'antd';
import type { FunctionComponent } from 'react';

export const CardPlaceholder: FunctionComponent = () => (
  <Card
    cover={
      <Skeleton.Image
        active
        css={{
          width: '100%',
          '& >.ant-skeleton-image': {
            width: '100%',
            height: '200px',
          },
        }}
      />
    }
  >
    <Skeleton paragraph={{ rows: 1 }} css={{ height: '82px' }}></Skeleton>
  </Card>
);
